import { useState, useEffect, useRef } from 'react';

const useCountDown = (
  initialCountDownTimeInMS = 1000,
  intervalTimeInMS = 1000,
  preventDefault = false,
  useHours = false,
) => {
  const [countDown, setCountDown] = useState(initialCountDownTimeInMS);
  const interval = useRef();
  const countDownIsOver = countDown <= 0;
  let hours;
  let leftMinutes;
  let seconds;

  const clear = () => clearInterval(interval.current);

  const updateTimer = () => {
    leftMinutes = parseInt(countDown / 60000, 10);
    seconds = parseInt((countDown / 1000) % 60, 10);

    seconds = seconds < 10 ? `0${seconds}` : seconds;
    if (useHours) {
      hours = parseInt(leftMinutes / 60, 10);
      leftMinutes %= 60;
      leftMinutes = leftMinutes < 10 ? `0${leftMinutes}` : leftMinutes;
      hours = hours < 10 ? `0${hours}` : hours;
      return `${hours}:${leftMinutes}:${seconds}`;
    }
    return `${leftMinutes}:${seconds}`;
  };

  const startCounter = (timeSeconds) => {
    let currentCountDown = timeSeconds || initialCountDownTimeInMS;
    setCountDown(currentCountDown);
    if (currentCountDown <= 0) return clear;

    // startCounter can be called multiple times, so we need to clear the previous interval
    clear();
    interval.current = setInterval(() => {
      currentCountDown -= intervalTimeInMS;
      currentCountDown = currentCountDown < 0 ? 0 : currentCountDown;
      setCountDown(currentCountDown);

      if (currentCountDown <= 0) clear();
    }, intervalTimeInMS);

    return clear;
  };

  useEffect(() => {
    if (!preventDefault) startCounter();
  }, [initialCountDownTimeInMS, intervalTimeInMS, preventDefault]);

  useEffect(() => clear, []);

  return {
    clear,
    countDown,
    countDownHumanize: updateTimer(),
    countDownIsOver,
    startCounter,
  };
};

export default useCountDown;
